﻿import {Store} from "@2d-front-monorepo/core";
import {
	CreditCardProvider,
	HolderId,
	HolderType,
	IAllPermitsReservations,
	InstallationId,
	IntegraHolderData,
	IntegraUserState,
	BillingMode,
	VoidReservation
} from "@2d-front-monorepo/permits-business";

import React, {Context, createContext, JSX, useEffect, useState} from "react";

export interface PermitsState extends IAllPermitsReservations {
	hasArchivedPermits: boolean;
	hasArchivedReservations: boolean;
	holderData: IntegraHolderData;
	installationId: InstallationId;
	userState: IntegraUserState;
	voidReservations: VoidReservation[];
}

export const permitsStore: Store<PermitsState> = new Store<PermitsState>({
	installationId: "" as InstallationId,
	userState: {
		userCurrency: "",
		creditCardProvider: CreditCardProvider.Undefined,
		creditCardPan: "",
		billingMode: BillingMode.InvalidatedPaymethod,
		balance: 0
	},
	holder: {
		id: "" as HolderId,
		email: "",
		company: {},
		type: HolderType.Individual,
		attachments: [],
		customData: []
	},
	holderData: {
		billingInfo: null!,
		plates: [],
		paymentProviders: {
			providers: [],
			billingMode: BillingMode.PrepayWithoutPaymethodCurrently,
			creditCard: {
				provider: CreditCardProvider.Undefined,
				number: ""
			}
		}
	},
	drivers: [],
	residencies: [],
	vehicles: [],
	permits: [],
	reservations: [],
	hasArchivedPermits: false,
	hasArchivedReservations: false,
	voidReservations: []
});

export const PermitsContext: Context<Store<PermitsState>> = createContext<Store<PermitsState>>(permitsStore);

let version = 0;

export function PermitsProvider({children}: { children: React.ReactNode }): JSX.Element {
	const [, setVersion] = useState(0);

	useEffect(() => {
		return permitsStore.subscribe(() => setVersion(++version));
	}, []);

	return (
		<PermitsContext.Provider value={permitsStore}>
			{children}
		</PermitsContext.Provider>
	);
}
